module.exports = __webpack_public_path__ + "static/assets/051cc58724149226b23311d799c1c144.png";